import React, { useEffect, useCallback, useMemo, useState } from "react";
import Navbar from "../components/Navbar.js";
import Sidebar from "../components/Sidebar.js";
import { Await, Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { Scrollbars } from "react-custom-scrollbars";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useSelector, useDispatch } from "react-redux";
//STATE ACTIONS
import {
  setPanning,
  setCustomMen,
  setSettings,
} from "../redux/action/toolpage/action";

//COMPONENTS
import LoadEnv from "../scene/LoadEnv";
import HairTypes from "../components/tool/HairTypes";
import ShirtTypes from "../components/tool/ShirtTypes";
import PantTypes from "../components/tool/PantTypes";
import ShoeTypes from "../components/tool/ShoeTypes";
import AnimationTypes from "../components/tool/AnimationTypes";

import {
  get_User_Accessories,
  ipfsImageHash,
  ipfsmetadatafunciton,
  TokenAddItemAction,
  TokenAddOwnerAction,
  updateDraftNft,
  getUserDraft,
} from "../apiAction/nfts.js";

import { connection } from "../../src/helper/connection.js";
import config from "../config/index.js";
import Web3 from "web3";
import BEP1155_ABI from "../../src/ABI/NFT1155.json";
import { toast } from "react-toastify";
import {
  Dropdown,
  Accordion,
  Modal,
  Form,
  FormControl,
  Tab,
  Nav,
  Row,
  Col,
} from "react-bootstrap";

import PropagateLoader from "react-spinners/PropagateLoader";

const override = {
  margin: "0 auto",
  borderColor: "red",
  position: "fixed",
  top: "50%",
  left: "50%",
  marginLeft: "-32px",
  marginTop: "-32px",
  zIndex: "99999",
};
// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

const initialvalue = {
  price: "",
  royality: "",
  noOfToken: "",
};

export default function CustomizeAvatar(props) {
  //STATE
  const avatarTool = useSelector((state) => state.avatarTool);
  const walletConnection = useSelector((state) => state.walletConnection);

  const dispatch = useDispatch();

  const [activeButton, setActiveButton] = useState("hair");
  const [accessories, setassessories] = useState([]);
  const [ValidateError, Set_ValidateError] = useState({});

  const [showMint, setshowMint] = useState(false);
  const [field, setfield] = useState(initialvalue);
  const [FormSubmitLoading, Set_FormSubmitLoading] = useState(false);

  const [autocall, setautocall] = useState(false);
  const [autocall1, setautocall1] = useState(false);

  const [myDraft, setmyDraft] = useState([]);

  let { price, royality, noOfToken } = field;

  const handleChangePop = (e) => {
    try {
      let { value, name, id } = e.target;
      console.log(value, name, "name");
      let formdata = { ...field, [name]: value };
      console.log(formdata, "formdata");

      setfield(formdata);
    } catch (err) {
      console.log(err);
    }
  };

  const handleButtonClick = (types) => {
    setActiveButton(types);
    let Details = {
      info: avatarTool?.ui,
    };
    Details.info.option = types;
    dispatch(setPanning(Details));

    //ANIMATION SET TO IDLE
    if (
      types !== "animation" &&
      avatarTool?.settings?.animationType !== "idle"
    ) {
      let Details = {
        animationType: "idle",
        model: avatarTool?.settings?.model,
        customize: avatarTool?.settings?.customize,
      };
      dispatch(setSettings(Details));
    }
  };

  useEffect(() => {
    if (walletConnection) {
      getUserAccessories();
      getMyDraft();
    }
  }, [activeButton, walletConnection]);

  const getMyDraft = async () => {
    try {
      let getdata = await getUserDraft({ address: walletConnection.address });
      console.log(getdata?.data, "getdata");

      if (getdata?.data?.success) {
        let details = {
          info: getdata?.data?.data?.customAvatar[0],
        };
        dispatch(setCustomMen(details));

        setmyDraft(getdata.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // save changes - avatar
  // useEffect(() => {
  //   setautocall(false);

  //   downloadImg(avatarTool?.ui?.avatarModel, avatarTool?.ui?.avatarImage);
  // }, [autocall]);

  function convert(n) {
    var sign = +n < 0 ? "-" : "",
      toStr = n.toString();
    if (!/e/i.test(toStr)) {
      return n;
    }
    var [lead, decimal, pow] = n
      .toString()
      .replace(/^-/, "")
      .replace(/^([0-9]+)(e.*)/, "$1.$2")
      .split(/e|\./);
    return +pow < 0
      ? sign +
          "0." +
          "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) +
          lead +
          decimal
      : sign +
          lead +
          (+pow >= decimal.length
            ? decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))
            : decimal.slice(0, +pow) + "." + decimal.slice(+pow));
  }

  //Reset Avatar
  const resetAvatar = () => {
    let Details = {
      info: avatarTool?.men,
    };
    Details.info = {
      option: "hair",
      hair: {
        type: "type_1",
        color: "0x000000",
      },
      shirt: {
        type: "type_1",
      },
      pant: {
        type: "type_1",
      },
      shoe: {
        type: "type_1",
      },
    };
    dispatch(setCustomMen(Details));
  };

  // get user accessories
  const getUserAccessories = async () => {
    try {
      setassessories("");
      let reqbody = {
        type: activeButton,
        address: walletConnection.address,
      };

      let data = await get_User_Accessories(reqbody);
      console.log(data, "data------123");
      setassessories(data?.data);
      console.log(reqbody, "reqbody");
    } catch (err) {
      console.log(err);
    }
  };

  const downloadAvatar = () => {
    let Details = {
      info: avatarTool?.ui,
    };
    Details.info.download = Math.floor(Math.random() * 100);
    dispatch(setPanning(Details));
    setautocall(true);

    
    downloadImg(avatarTool?.ui?.avatarModel, avatarTool?.ui?.avatarImage);

  };

  const navigate = useNavigate();
  const handleClickAvatar = () => {
    navigate("/avatar");
  };



  const ItemValidation = async () => {
    var ValidateError = {};

    if (price == 0) {
      ValidateError.price = '"price" must be greater than 0';
    } else if (price == "") {
      ValidateError.price = '"price" must be greater than 0';
    }
    if (royality == 0) {
      ValidateError.royality = '"royality" must be greater than 0';
    } else if (royality == "") {
      ValidateError.royality = '"royality" must be greater than 0';
    }
    if (noOfToken == 0) {
      ValidateError.noOfToken = '"No Of Token" must be greater than 0';
    } else if (noOfToken == "") {
      ValidateError.noOfToken = '"No Of Token" must be greater than 0';
    }
    Set_ValidateError(ValidateError);
    return ValidateError;
  };

  const downloadImg = async (avatarModelFile, avatarImage) => {
    try {
      var errors = await ItemValidation();
      var errorsSize = Object.keys(errors).length;
      if (errorsSize != 0) {
        // toast.error(
        //   "Form validation error, please fill all the required fields",
        //   toasterOption
        // );
        return false;
      }
      
      if(!avatarTool?.ui?.avatarModel){
        toast.error(`Please Click again`, {
          toastId: "12",
        });
        return false
      }
      Set_FormSubmitLoading(true);

      let data = {
        image: avatarModelFile,
        Imagefile: avatarImage,
      };
      console.log("payload data:=", data);

      let getHash = await ipfsImageHash(data);

      console.log(getHash, "getHash");

      let ipfs_url = getHash.data.ipfsUrl;
      let ipfs_hash = getHash.data.ipfsval;
      let filename = getHash.data.filename;
      let fileImage = getHash.data.Imagefile;

      if (getHash) {
        Set_FormSubmitLoading(true);
        var unix = Math.round(new Date() / 1000);
        let ran = Math.floor(Math.random() * 100 + 1);
        let tokenid = unix + ran;
        let nftName = "NFT" + tokenid;

        let collRoyalty = royality;
        let TokenQuantity = noOfToken;

        let Price1 = price * 1e18;
        let TokenPriceInStr = Price1.toString();
        //  TokenPriceInStr = convert(price);

        var newobj = {
          name: nftName,
          tokenId: tokenid,
          image: config.IPFS_IMG + "/" + ipfs_hash,
        };

        var ipfsmetatagVal = await ipfsmetadatafunciton(newobj);
        console.log(ipfsmetatagVal, "ipfsmetatagVal");

        var mydata = await connection();
        const web3 = new Web3(
          mydata &&
          mydata.provider &&
          mydata.provider != null &&
          mydata.provider != undefined &&
          mydata.provider != ""
            ? mydata.provider
            : window.ethereum
        );
        var currAddr = await web3.eth.getAccounts();

        console.log(currAddr, "currAddr");

        const BEP1155Contract = new web3.eth.Contract(
          BEP1155_ABI,
          config.multipleContract
        );

        console.log(
          tokenid,
          TokenPriceInStr,
          collRoyalty.toString(),
          TokenQuantity.toString(),
          nftName,
          ipfs_hash,
          ipfs_url,
          "currAddr"
        );
        try {
          BEP1155Contract.methods
            .mint(
              tokenid,
              TokenPriceInStr,
              collRoyalty.toString(),
              TokenQuantity.toString(),
              nftName,
              ipfs_hash,
              ipfs_url
            )
            .send({
              from: currAddr[0],
            })
            .then(async (result) => {
              var transactionHash = "";
              if (result.transactionHash) {
                transactionHash = result.transactionHash;
              } else {
                transactionHash = result;
              }

              var TokenAddItemPayload = {
                Filename: filename,
                Image: fileImage,
                ipfsimage: ipfs_url,
                Name: nftName,
                Count: tokenid,
                Description: "TokenDescription",
                Price: price,
                TokenPrice: 0,
                Royalities: collRoyalty,
                Category_label: "Music",
                Owner: walletConnection.address,
                Creator: walletConnection.address,
                Quantity: TokenQuantity,
                Balance: TokenQuantity,
                ContractAddress: config.multipleContract,
                Status: true,
                // HashValue: "djksaldnsajkdbsadkasjb",
                HashValue: transactionHash,

                Type: 1155,
                MinimumBid: 0,
                Nft_type: 3, // 1 - accessories 2 -noraml nft
                MaximumBid: 0,
                Clocktime: "",
                EndClocktime: "",
                UnLockcontent: "",
                PutOnSale: true,
                PutOnSaleType: "FixedPrice",
                currencyName: "BNB",
              };

              console.log(TokenAddItemPayload, "TokenAddItemPayload");

              await TokenAddItemAction(TokenAddItemPayload);
              var TokenAddOwnerPayload = {
                Count: tokenid,
                Price: price,
                TokenPrice: 0,
                Owner: walletConnection.address,
                Balance: TokenQuantity,
                Quantity: TokenQuantity,
                ContractAddress: config.multipleContract,
                Type: 1155,
                HashValue: transactionHash,
                // HashValue: "rghewrjwejk",

                Status: true,
                currencyName: "BNB",
              };

              console.log(TokenAddOwnerPayload, "TokenAddOwnerPayload");

              await TokenAddOwnerAction(TokenAddOwnerPayload);
              Set_FormSubmitLoading(false);

              setTimeout(() => {
                window.location.reload();
              }, 2000);
            });
        } catch (err) {
          Set_FormSubmitLoading(false);

          console.log(err);
        }
      } else {
        Set_FormSubmitLoading(false);
      }
    } catch (err) {
      Set_FormSubmitLoading(false);

      console.log(err);
    }
  };

  const handleshow = () => {
    setshowMint(true);
  };
  const handleClose2 = () => {
    setshowMint(false);
  };

  const saveDraftAvatar = () => {
    let Details = {
      info: avatarTool?.ui,
    };
    Details.info.download = Math.floor(Math.random() * 100);
    dispatch(setPanning(Details));
    saveDraft_Nft();
  };

  const saveDraft_Nft = async () => {
    try {
      let avatarModelFile = avatarTool?.ui?.avatarModel;
      console.log(avatarModelFile, "avatarModelFile");
      if (!avatarModelFile) {
        toast.error(`Please Click again`, {
          toastId: "12",
        });
        setautocall1(false);
        return false;
      }

      let reqdata = {
        address: walletConnection?.address,
        image: avatarModelFile,
        customAvatar: JSON.stringify(avatarTool?.men),
      };

      const data = await updateDraftNft(reqdata);
      console.log(data.data, "dataaaaa");

      if (data.data.success) {
        toast.success(data.data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  // useMemo(() => {
  //   // setautocall1(false);

  //   saveDraft_Nft(avatarTool?.ui?.avatarModel);
  // }, [autocall1]);

  return (
    <>
      <ScrollToTopOnMount />
      <div className="apppage_wrapper">
        <div className="app_page">
          <Navbar />
          <div className="page_wrapper">
            <Sidebar />
            <div className="page_content">
              <div className="page_content_layout">
                <div className="avatar_content">
                  <div className="avatar_content_layout">
                    <div class="backdrop canvas_overlay"></div>
                    <div className="avatar_left_column">
                      <button
                        className="back_btn d-xl-flex d-none"
                        onClick={handleClickAvatar}
                      >
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                        >
                          <path
                            d="M6 11.5C5.86748 11.4982 5.74042 11.4469 5.64375 11.3562L0.643755 6.35623C0.549865 6.26143 0.497192 6.1334 0.497192 5.99998C0.497192 5.86656 0.549865 5.73853 0.643755 5.64373L5.64375 0.643731C5.7409 0.563999 5.86423 0.523253 5.98976 0.529419C6.11529 0.535584 6.23403 0.588219 6.3229 0.677086C6.41177 0.765954 6.4644 0.884699 6.47057 1.01023C6.47673 1.13575 6.43599 1.25908 6.35625 1.35623L1.70626 5.99998L6.35625 10.6437C6.45015 10.7385 6.50282 10.8666 6.50282 11C6.50282 11.1334 6.45015 11.2614 6.35625 11.3562C6.25959 11.4469 6.13253 11.4982 6 11.5Z"
                            fill="white"
                            stroke="white"
                            stroke-width="0.5"
                          ></path>
                        </svg>
                        Back
                      </button>
                      <h3>Customize your Avatar</h3>
                      <div className="avatar_left_column_container">
                        <div className="step_min scroll_step"></div>
                        <div className="step_max scroll_step canvas_overlay_top">
                          <div className="avatar_left_column_mobile_box">
                            <div className="line"></div>
                          </div>
                          <div className="custom_tabbtn_grp">
                            <button
                              className={
                                activeButton === "hair" ? "active" : ""
                              }
                              onClick={() => handleButtonClick("hair")}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                              >
                                <path
                                  d="M12.6561 9.08794C12.6585 8.90099 12.6247 8.71539 12.5567 8.54179C12.4887 8.36818 12.3879 8.20996 12.2599 8.07618C12.132 7.9424 11.9795 7.83568 11.8111 7.76214C11.6427 7.68861 11.4617 7.64968 11.2786 7.64761C11.238 7.64761 11.1972 7.64761 11.1561 7.64761C10.5263 7.61091 9.93225 7.33703 9.48889 6.87898C9.04553 6.42092 8.78438 5.81125 8.75599 5.16797C8.75599 5.15887 8.75599 5.14977 8.75599 5.14067C8.7493 4.90056 8.65187 4.67241 8.4841 4.50398C8.31634 4.33555 8.09125 4.2399 7.85596 4.23706H6.64405C5.81554 4.24586 5.02436 4.59021 4.4445 5.19437C3.86463 5.79854 3.54356 6.61307 3.55188 7.45885L3.48801 11.4516C3.47633 12.6457 3.92967 13.7956 4.74835 14.6486C5.56704 15.5015 6.68404 15.9876 7.85374 16H8.22504C9.39474 15.9876 10.5117 15.5015 11.3304 14.6486C12.1491 13.7956 12.6024 12.6457 12.5908 11.4516C12.5908 11.4516 12.6576 10.1303 12.6561 9.08794Z"
                                  fill="#DEE0E2"
                                ></path>
                                <path
                                  d="M15.3562 10.554V8.34654H16C16 8.34654 15.6287 6.59843 15.3562 5.85098C15.2026 5.30868 15.2026 4.7331 15.3562 4.19081C15.3562 1.71723 11.1085 0.180626 10.0169 0.050996C8.4222 -0.140903 6.81017 0.212053 5.43284 1.05468C4.48696 1.07305 3.5523 1.26752 2.67484 1.62854C2.25972 1.82184 0.696555 3.30084 0.708437 4.57742V5.6607L0 7.92126L0.708437 7.62789V10.554L2.67484 12.4826V10.554C2.37639 10.4575 2.1174 10.2633 1.93793 10.0015C1.75846 9.73959 1.66851 9.42466 1.68198 9.10537C1.65974 8.95891 1.66875 8.80928 1.70837 8.6667C1.748 8.52412 1.81731 8.39196 1.91158 8.27924C2.00585 8.16653 2.12284 8.07592 2.25457 8.01362C2.3863 7.95131 2.52966 7.91877 2.67484 7.91823V7.03357C2.67542 5.95569 3.09483 4.92207 3.84102 4.15947C4.58722 3.39687 5.59928 2.96758 6.65516 2.96577H7.79579C8.29057 2.9654 8.76623 3.16083 9.12281 3.51099C9.4794 3.86115 9.68914 4.33878 9.70797 4.84351V4.85867C9.72728 5.18859 9.86506 5.49966 10.0949 5.73239C10.3248 5.96511 10.6307 6.10315 10.9541 6.12009H11.0127H11.0283C12.3264 6.12009 13.3853 6.58706 13.3868 7.91899C13.3868 8.04407 14.2556 7.90686 14.3366 9.10612C14.3746 9.42341 14.2998 9.7441 14.1258 10.0098C13.9518 10.2756 13.69 10.4687 13.3883 10.554V12.4826L15.3562 10.554Z"
                                  fill="#DEE0E2"
                                ></path>
                              </svg>
                            </button>
                            <button
                              className={
                                activeButton === "shirt" ? "active" : ""
                              }
                              onClick={() => handleButtonClick("shirt")}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                              >
                                <path
                                  d="M7.99985 1.68209C8.38014 1.68331 8.75097 1.5518 9.05899 1.30648C9.36702 1.06116 9.59636 0.714686 9.71403 0.316895C8.58911 0.618734 7.41472 0.618734 6.28979 0.316895C6.40725 0.713949 6.63597 1.0599 6.94317 1.30515C7.25037 1.5504 7.62028 1.68235 7.99985 1.68209Z"
                                  fill="#DEE0E2"
                                ></path>
                                <path
                                  d="M15.9795 2.46566C15.9638 2.41356 15.9389 2.3654 15.9061 2.32397C15.8734 2.28253 15.8336 2.24866 15.7889 2.2243L12.7383 0.605666C12.0931 0.354283 11.4322 0.154391 10.7608 0.00754272C10.7383 0.00255145 10.7153 2.4831e-05 10.6923 0C10.609 0.00149976 10.5288 0.0344947 10.4651 0.0934301C10.4015 0.152366 10.3582 0.233643 10.3426 0.323576C10.2356 0.923617 9.94479 1.46514 9.51864 1.85774C9.09248 2.25034 8.55679 2.47024 8.00101 2.48074C7.44522 2.47024 6.90953 2.25034 6.48338 1.85774C6.05722 1.46514 5.76639 0.923617 5.65944 0.323576C5.6437 0.233581 5.60028 0.152289 5.53647 0.0933625C5.47267 0.0344365 5.39236 0.00146828 5.30906 0C5.28604 2.4831e-05 5.26307 0.00255145 5.2405 0.00754272C4.56894 0.154557 3.90785 0.354445 3.26234 0.605666L0.210417 2.22505C0.165592 2.2491 0.125656 2.28289 0.0930144 2.32437C0.0603731 2.36585 0.0357017 2.41417 0.0204861 2.46641C-0.0123905 2.57306 -0.00548637 2.68969 0.0396849 2.79074L1.36371 5.79343C1.39244 5.86068 1.43789 5.91762 1.49479 5.95766C1.5517 5.9977 1.61774 6.01922 1.68529 6.01971C1.72041 6.01972 1.75532 6.01387 1.78883 6.00236L3.25959 5.50153V15.5844C3.25775 15.6922 3.2948 15.7965 3.36265 15.8744C3.43049 15.9523 3.5236 15.9974 3.62163 16H12.3776C12.4756 15.9974 12.5687 15.9522 12.6364 15.8743C12.7041 15.7964 12.741 15.6922 12.739 15.5844V5.50455L14.2111 6.00537C14.2446 6.01696 14.2795 6.02281 14.3147 6.02272C14.3822 6.02205 14.4482 6.00047 14.505 5.96045C14.5619 5.92043 14.6074 5.86359 14.6362 5.79644L15.961 2.79225C16.0056 2.6902 16.0122 2.57302 15.9795 2.46566Z"
                                  fill="#DEE0E2"
                                ></path>
                              </svg>
                            </button>
                            <button
                              className={
                                activeButton === "pant" ? "active" : ""
                              }
                              onClick={() => handleButtonClick("pant")}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                              >
                                <g clip-path="url(#clip0_1957_6189)">
                                  <path
                                    d="M2.5865 1.60791H13.4724L13.7636 3.28292L11.9096 3.05643L12.9291 4.32361H13.9661L15.4225 12.7649L10.8523 13.8027C10.8523 13.8027 9.53425 6.7968 8.03925 6.7968C6.54426 6.7968 5.23059 13.8027 5.23059 13.8027L0.451416 12.762L2.0804 4.32143H3.07512L3.94022 3.05425L2.25808 3.32225L2.5865 1.60791Z"
                                    fill="#DEE0E2"
                                  ></path>
                                  <path
                                    d="M11.0789 14.6207L15.6075 13.4905L16 14.8989L11.3745 16.0001L11.0789 14.6207Z"
                                    fill="#DEE0E2"
                                  ></path>
                                  <path
                                    d="M4.92117 14.6207L0.392501 13.4905L0 14.8989L4.62989 16.0001L4.92117 14.6207Z"
                                    fill="#DEE0E2"
                                  ></path>
                                  <path
                                    d="M2.75244 0H13.4264V1.17542H2.75244V0Z"
                                    fill="#DEE0E2"
                                  ></path>
                                </g>
                                <defs>
                                  <clipPath id="clip0_1957_6189">
                                    <rect
                                      width="16"
                                      height="16"
                                      fill="white"
                                    ></rect>
                                  </clipPath>
                                </defs>
                              </svg>
                            </button>
                            <button
                              className={
                                activeButton === "shoe" ? "active" : ""
                              }
                              onClick={() => handleButtonClick("shoe")}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                              >
                                <path
                                  d="M13.6515 9.46207C13.0492 9.15497 12.5126 8.684 12.0827 8.08524L11.4871 7.17102C11.4871 7.17102 11.568 7.27241 11.3825 6.98689L10.289 8.33967C10.2452 8.39387 10.193 8.43702 10.1355 8.46666C10.0779 8.49629 10.0162 8.51183 9.95375 8.51238C9.8913 8.51294 9.82937 8.4985 9.7715 8.46989C9.71363 8.44128 9.66095 8.39907 9.61647 8.34565C9.57198 8.29224 9.53657 8.22867 9.51225 8.15859C9.48793 8.0885 9.47518 8.01326 9.47473 7.93716C9.47427 7.86107 9.48612 7.78561 9.5096 7.7151C9.53307 7.64458 9.56772 7.58039 9.61156 7.52619L10.7888 6.07026C10.6036 5.7833 9.97955 4.84584 9.80491 4.57581L8.71141 5.92859C8.62254 6.03467 8.50307 6.09406 8.37866 6.09403C8.25425 6.094 8.13481 6.03454 8.04597 5.92842C7.95713 5.8223 7.90597 5.67797 7.90348 5.52641C7.90098 5.37485 7.94734 5.22814 8.03262 5.11776L9.20988 3.66182L8.40639 2.41818C8.33786 2.3134 8.24163 2.24082 8.13411 2.21278C8.02659 2.18475 7.91441 2.203 7.81669 2.26443L6.64061 2.99459C6.38328 3.15094 6.0857 3.17723 5.81255 3.06774C5.5394 2.95826 5.31275 2.72184 5.18185 2.40988C5.05154 2.09602 4.85507 1.83003 4.61259 1.63918C4.37011 1.44834 4.09035 1.33949 3.80197 1.32381C3.51359 1.30813 3.22697 1.38617 2.9715 1.54994C2.71604 1.71371 2.50091 1.95732 2.34817 2.25578L1.36384 4.51673C1.34321 4.55679 1.32669 4.59978 1.31465 4.64474L0.68513 7.00551C0.603988 7.3098 0.576947 7.61239 0.824309 7.71032L2.35404 8.31596C4.47375 9.21416 3.44588 10.1098 8.57068 12.0822C9.5983 12.5688 11.2597 13.1468 12.1367 13.494L12.2201 13.5271C13.2262 13.9253 13.9448 12.9479 14.2126 11.9777C14.3782 11.5453 14.4127 11.0553 14.31 10.5948C14.2072 10.1343 13.974 9.73296 13.6515 9.46207Z"
                                  fill="#DEE0E2"
                                ></path>
                                <path
                                  d="M0.589609 8.86033C0.797321 8.68985 2.74987 9.63588 3.11115 9.85863C3.47244 10.0814 3.93324 10.613 4.63772 11.2195C5.3422 11.8261 8.90244 13.3823 11.2993 14.1367C13.6961 14.8912 13.5695 13.8916 13.8239 13.8329C13.7001 14.2972 11.9364 15.4205 11.0669 15.1186C10.1975 14.8166 4.11891 12.3678 4.11891 12.3678L2.29555 11.0918L0.272782 10.1515C0.257032 9.69006 0.368573 9.2355 0.589609 8.86033Z"
                                  fill="#DEE0E2"
                                ></path>
                              </svg>
                            </button>

                            <button
                              className={
                                activeButton === "animation" ? "active" : ""
                              }
                              onClick={() => handleButtonClick("animation")}
                            >
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="icon"
                              >
                                <path
                                  d="M9.99764 1.71336C9.99764 2.05226 9.88035 2.38355 9.66059 2.66533C9.44084 2.9471 9.1285 3.16671 8.76308 3.29637C8.39766 3.42602 7.99557 3.45991 7.60767 3.39374C7.21977 3.32756 6.86348 3.16431 6.58388 2.92461C6.30427 2.68492 6.1139 2.37956 6.03685 2.04715C5.9598 1.71474 5.99952 1.37021 6.151 1.05715C6.30248 0.744091 6.55891 0.476555 6.88785 0.288381C7.21679 0.100207 7.60347 -0.00015126 7.99898 1.71119e-07C8.52914 0.000203155 9.03751 0.180807 9.4123 0.502101C9.7871 0.823396 9.99764 1.25908 9.99764 1.71336Z"
                                  fill="white"
                                ></path>
                                <path
                                  d="M14.9993 3.9986H0.999777C0.868484 3.9986 0.738477 4.02076 0.617179 4.06381C0.49588 4.10686 0.385665 4.16997 0.292828 4.24952C0.19999 4.32907 0.126347 4.42351 0.0761035 4.52744C0.02586 4.63138 0 4.74278 0 4.85528C0 4.96778 0.02586 5.07918 0.0761035 5.18312C0.126347 5.28705 0.19999 5.38149 0.292828 5.46104C0.385665 5.54059 0.49588 5.6037 0.617179 5.64675C0.738477 5.6898 0.868484 5.71196 0.999777 5.71196H5.10342C5.26575 5.73118 5.41861 5.78879 5.54487 5.87831C5.67112 5.96783 5.76576 6.08573 5.81818 6.21877C5.96974 6.82785 5.96272 7.45807 5.79763 8.06457L5.63949 8.83014C5.64038 8.83183 5.64084 8.83366 5.64084 8.8355C5.64084 8.83735 5.64038 8.83918 5.63949 8.84086L4.37257 14.9884C4.34943 15.0995 4.35209 15.2134 4.38041 15.3235C4.40873 15.4337 4.46214 15.538 4.53759 15.6305C4.61303 15.7229 4.70903 15.8017 4.82008 15.8623C4.93113 15.9229 5.05504 15.9642 5.18472 15.9837C5.31363 16.0033 5.4458 16.0009 5.57359 15.9764C5.70138 15.952 5.82224 15.9061 5.92919 15.8414C6.03613 15.7767 6.12703 15.6944 6.19662 15.5994C6.26621 15.5044 6.31311 15.3984 6.3346 15.2878L7.20929 11.0074V11.0143C7.20929 11.0143 7.4675 9.85372 7.98034 9.85372H8.02591C8.54679 9.85372 8.79696 11.0143 8.79696 11.0143L9.67165 15.2947C9.69465 15.4052 9.74284 15.5109 9.81348 15.6055C9.88412 15.7001 9.97581 15.7819 10.0833 15.8462C10.1909 15.9105 10.3121 15.9559 10.4401 15.9801C10.5682 16.0042 10.7005 16.0064 10.8296 15.9867C10.9586 15.967 11.0819 15.9257 11.1923 15.8652C11.3028 15.8047 11.3982 15.7261 11.4732 15.634C11.5482 15.5418 11.6013 15.438 11.6295 15.3282C11.6576 15.2185 11.6603 15.1051 11.6373 14.9946L10.3641 8.83933C10.365 8.83765 10.3654 8.83582 10.3654 8.83397C10.3654 8.83212 10.365 8.8303 10.3641 8.82861L10.2059 8.06304C10.0409 7.45654 10.0338 6.82632 10.1854 6.21724C10.2378 6.0842 10.3325 5.9663 10.4587 5.87678C10.585 5.78726 10.7378 5.72965 10.9002 5.71043H15.0002C15.1315 5.71043 15.2615 5.68827 15.3828 5.64522C15.5041 5.60216 15.6143 5.53906 15.7072 5.45951C15.8 5.37996 15.8737 5.28552 15.9239 5.18159C15.9741 5.07765 16 4.96625 16 4.85375C16 4.74125 15.9741 4.62985 15.9239 4.52591C15.8737 4.42197 15.8 4.32754 15.7072 4.24799C15.6143 4.16844 15.5041 4.10533 15.3828 4.06228C15.2615 4.01923 15.1315 3.99707 15.0002 3.99707L14.9993 3.9986Z"
                                  fill="white"
                                ></path>
                              </svg>
                            </button>
                          </div>
                          <div className="avatar_left_column_tabcontent">
                            {activeButton === "hair" && (
                              <>
                                <HairTypes accessories={accessories} />
                              </>
                            )}
                            {activeButton === "shirt" && (
                              <>
                                <ShirtTypes accessories={accessories} />
                              </>
                            )}
                            {activeButton === "pant" && (
                              <>
                                <PantTypes accessories={accessories} />
                              </>
                            )}
                            {activeButton === "shoe" && (
                              <>
                                <ShoeTypes accessories={accessories} />
                              </>
                            )}
                            {activeButton === "animation" && (
                              <>
                                <AnimationTypes accessories={accessories} />
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="avatar_center_column"></div>
                    <div className="avatar_right_column">
                      <div className="header canvas_overlay_top">
                        <button
                          className="back_btn"
                          onClick={handleClickAvatar}
                        >
                          <svg
                            width="7"
                            height="12"
                            viewBox="0 0 7 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                          >
                            <path
                              d="M6 11.5C5.86748 11.4982 5.74042 11.4469 5.64375 11.3562L0.643755 6.35623C0.549865 6.26143 0.497192 6.1334 0.497192 5.99998C0.497192 5.86656 0.549865 5.73853 0.643755 5.64373L5.64375 0.643731C5.7409 0.563999 5.86423 0.523253 5.98976 0.529419C6.11529 0.535584 6.23403 0.588219 6.3229 0.677086C6.41177 0.765954 6.4644 0.884699 6.47057 1.01023C6.47673 1.13575 6.43599 1.25908 6.35625 1.35623L1.70626 5.99998L6.35625 10.6437C6.45015 10.7385 6.50282 10.8666 6.50282 11C6.50282 11.1334 6.45015 11.2614 6.35625 11.3562C6.25959 11.4469 6.13253 11.4982 6 11.5Z"
                              fill="white"
                              stroke="white"
                              stroke-width="0.5"
                            ></path>
                          </svg>
                          Back
                        </button>

                        <button
                          className="button_icon_square filter_button display_anim_btn"
                          id="dropdownMenuAvatarAnim"
                          data-bs-toggle="dropdown"
                          data-bs-auto-close="outside"
                          aria-expanded="false"
                        >
                          <svg
                            width="15"
                            height="22"
                            viewBox="0 0 15 22"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="animate"
                          >
                            <path
                              d="M6.99686 14.9051L7.34113 14.8304L7.15927 13.2447H7.56227V15.0853H7.85489V15.864L7.22543 16.3857L6.99686 14.9051ZM6.35715 0L6.30089 0.610207L5.60917 0.601712L5.41562 2.55798L5.28188 4.33445L5.68312 4.35285V5.02182L6.58289 5.58813L6.56909 6.1003L5.44888 6.09676L3.2198 5.34462L3.22439 5.53398L2.84616 5.37258L2.15408 2.71443L2.64306 2.55303L2.23263 1.11317L1.21326 1.12272L0 1.49154L0.424588 3.04183L0.61813 3.06944L1.50269 6.27196L4.56999 7.31929V8.45936H5.28966L5.30169 9.85038L5.30735 11.1352V11.4725H4.98891L5.05579 12.7977L4.83217 12.8773L5.56635 16.5071L5.38944 16.5283L5.56635 18.0786L5.56211 18.0814L5.63853 18.732H5.64243L5.96936 18.6842L6.07551 19.9744L6.08577 20.0968L6.09178 20.1043L6.16715 20.712L6.32672 20.707L6.59244 22L7.7314 21.7876L8.33785 20.9948L8.14644 20.1807L7.93909 20.2076L7.88036 19.9467H7.70345L7.43207 18.2754L9.48424 16.7665L9.221 16.5032H9.63568V15.081H9.82356L9.78818 12.2547H9.49415V11.137H9.03099V9.96895L9.0409 8.72164L9.78818 8.78605L9.82356 7.8357L12.9415 7.49414L14.1682 5.06712L14.3451 5.09473L14.4834 4.76237L14.6218 4.80839L15 4.00563L14.0224 3.44356L13.5978 3.42516L13.487 3.61877L13.2394 3.54479L12.8601 4.40311L13.1184 4.6707L12.1864 6.59016L11.4207 6.70095V6.47937L9.70503 6.62697L9.68663 6.46097L8.24763 6.33178L8.26709 5.82669L9.2447 5.92828L9.47858 5.70104L9.93608 5.7598L10.3876 2.7254L10.6642 2.7608L10.9225 0.988931H10.7209V0.628612L8.5091 0H6.35715Z"
                              fill="white"
                            ></path>
                          </svg>
                        </button>
                        
                      </div>
                      <ul
                        className="dropdown-menu dropdown-menu-dark dropdownmenu_custom"
                        aria-labelledby="dropdownMenuAvatarAnim"
                      >
                        <li>
                          <a className="dropdown-item" href="#">
                            Idle
                            <svg
                              width="14"
                              height="10"
                              viewBox="0 0 14 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="AvatarAnim_active_icon"
                            >
                              <path
                                d="M5.31254 9.49998C5.16345 9.49795 5.0205 9.44027 4.91176 9.33826L0.974258 5.40076C0.88456 5.29147 0.838721 5.15272 0.845657 5.0115C0.852593 4.87029 0.911807 4.7367 1.01178 4.63672C1.11176 4.53675 1.24535 4.47753 1.38656 4.4706C1.52778 4.46366 1.66653 4.5095 1.77582 4.5992L5.31254 8.14295L12.7868 0.661698C12.896 0.572 13.0348 0.52616 13.176 0.533096C13.3172 0.540031 13.4508 0.599246 13.5508 0.699222C13.6508 0.799198 13.71 0.932787 13.7169 1.074C13.7239 1.21522 13.678 1.35397 13.5883 1.46326L5.71332 9.33826C5.60458 9.44027 5.46163 9.49795 5.31254 9.49998Z"
                                fill="white"
                              ></path>
                            </svg>
                          </a>
                        </li>
                      </ul>
                      <div className="avatar_customize_options">
                        {/* <button
                          data-tooltip-id="my-tooltip"
                          data-tooltip-content="Randomize"
                          data-tooltip-place="left"
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M20 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4V20C0 21.0609 0.421427 22.0783 1.17157 22.8284C1.92172 23.5786 2.93913 24 4 24H20C21.0609 24 22.0783 23.5786 22.8284 22.8284C23.5786 22.0783 24 21.0609 24 20V4C24 2.93913 23.5786 1.92172 22.8284 1.17157C22.0783 0.421427 21.0609 0 20 0ZM22 20C22 20.5304 21.7893 21.0391 21.4142 21.4142C21.0391 21.7893 20.5304 22 20 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H20C20.5304 2 21.0391 2.21071 21.4142 2.58579C21.7893 2.96086 22 3.46957 22 4V20ZM9 7.5C9 7.79667 8.91203 8.08668 8.7472 8.33335C8.58238 8.58003 8.34811 8.77229 8.07403 8.88582C7.79994 8.99935 7.49834 9.02906 7.20736 8.97118C6.91639 8.9133 6.64912 8.77044 6.43934 8.56066C6.22956 8.35088 6.0867 8.08361 6.02882 7.79264C5.97094 7.50166 6.00065 7.20006 6.11418 6.92597C6.22771 6.65189 6.41997 6.41762 6.66665 6.2528C6.91332 6.08797 7.20333 6 7.5 6C7.89782 6 8.27936 6.15804 8.56066 6.43934C8.84196 6.72064 9 7.10218 9 7.5ZM13.5 12C13.5 12.2967 13.412 12.5867 13.2472 12.8334C13.0824 13.08 12.8481 13.2723 12.574 13.3858C12.2999 13.4993 11.9983 13.5291 11.7074 13.4712C11.4164 13.4133 11.1491 13.2704 10.9393 13.0607C10.7296 12.8509 10.5867 12.5836 10.5288 12.2926C10.4709 12.0017 10.5006 11.7001 10.6142 11.426C10.7277 11.1519 10.92 10.9176 11.1666 10.7528C11.4133 10.588 11.7033 10.5 12 10.5C12.3978 10.5 12.7794 10.658 13.0607 10.9393C13.342 11.2206 13.5 11.6022 13.5 12ZM18 16.5C18 16.7967 17.912 17.0867 17.7472 17.3334C17.5824 17.58 17.3481 17.7723 17.074 17.8858C16.7999 17.9993 16.4983 18.0291 16.2074 17.9712C15.9164 17.9133 15.6491 17.7704 15.4393 17.5607C15.2296 17.3509 15.0867 17.0836 15.0288 16.7926C14.9709 16.5017 15.0007 16.2001 15.1142 15.926C15.2277 15.6519 15.42 15.4176 15.6666 15.2528C15.9133 15.088 16.2033 15 16.5 15C16.8978 15 17.2794 15.158 17.5607 15.4393C17.842 15.7206 18 16.1022 18 16.5Z"
                              fill="white"
                            ></path>
                          </svg>
                        </button> */}
                        <button
                          data-tooltip-id="my-tooltip"
                          data-tooltip-content="Reset"
                          data-tooltip-place="left"
                          onClick={() => resetAvatar()}
                        >
                          <svg
                            width="27"
                            height="25"
                            viewBox="0 0 27 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M22.4875 21.4875C20.2352 23.7362 17.1826 24.9992 14 24.9992C10.8173 24.9992 7.76472 23.7362 5.51248 21.4875C5.32546 21.3 5.22044 21.046 5.22044 20.7812C5.22044 20.5164 5.32546 20.2624 5.51248 20.075C5.60445 19.9809 5.7143 19.9061 5.83559 19.855C5.95687 19.804 6.08713 19.7777 6.21873 19.7777C6.35032 19.7777 6.48058 19.804 6.60186 19.855C6.72315 19.9061 6.833 19.9809 6.92498 20.075C8.32394 21.4724 10.1058 22.4237 12.0453 22.8086C13.9848 23.1936 15.9949 22.9949 17.8215 22.2377C19.6481 21.4805 21.2093 20.1988 22.3076 18.5545C23.4059 16.9103 23.9921 14.9773 23.9921 13C23.9921 11.0226 23.4059 9.08967 22.3076 7.44542C21.2093 5.80117 19.6481 4.51944 17.8215 3.76223C15.9949 3.00503 13.9848 2.80635 12.0453 3.1913C10.1058 3.57625 8.32394 4.52755 6.92498 5.92496L4.38748 8.46246H7.97498C8.24019 8.46246 8.49455 8.56782 8.68208 8.75536C8.86962 8.94289 8.97498 9.19725 8.97498 9.46246C8.97498 9.72768 8.86962 9.98203 8.68208 10.1696C8.49455 10.3571 8.24019 10.4625 7.97498 10.4625H1.97498C1.70976 10.4625 1.45541 10.3571 1.26787 10.1696C1.08033 9.98203 0.974976 9.72768 0.974976 9.46246V3.46246C0.974976 3.19725 1.08033 2.94289 1.26787 2.75536C1.45541 2.56782 1.70976 2.46246 1.97498 2.46246C2.24019 2.46246 2.49455 2.56782 2.68208 2.75536C2.86962 2.94289 2.97498 3.19725 2.97498 3.46246V7.04996L5.51248 4.51246C7.7635 2.26144 10.8165 0.996826 14 0.996826C17.1834 0.996826 20.2365 2.26144 22.4875 4.51246C24.7385 6.76349 26.0031 9.81653 26.0031 13C26.0031 16.1834 24.7385 19.2364 22.4875 21.4875Z"
                              fill="white"
                            ></path>
                          </svg>
                        </button>
                        <ReactTooltip
                          id="my-tooltip"
                          className="custom_tooltip"
                        />
                      </div>
                      <div className="avatar_action_btns">
                        <Button
                          className="primary_btn"
                          variant="contained"
                          onClick={saveDraftAvatar}
                        >
                          Save changes
                        </Button>

                        <Button
                          className="primary_btn"
                          variant="contained"
                          onClick={handleshow}
                        >
                          Save and Mint
                        </Button>

                        {/* <Button
                          className="primary_btn"
                          variant="contained"
                          type="button"
                          onClick={() => downloadAvatar()}
                        >
                          Download
                        </Button> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="avatar_scene_renderer">
                  <div className="canvas_wrapper">
                    <LoadEnv />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="custom_modal"
        centered
        show={showMint}
        onHide={handleClose2}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>NFT Minting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <a href="#" className="nft_box">
              <a href="/nft-detail" className="img_box">
                <div className="bg"></div>
                <img
                  src={item?.ipfsimage}
                  alt="img"
                  className="img-fluid"
                />
              </a>
            </a> */}
          <p className="grey">
            You are about to place order for{" "}
            <span className="text-light">GN Quantum Levitator platform</span>
            from
          </p>

          <div class="mb-3 input_box">
            <lable>price</lable>
            <input
              type="number"
              class="form-control"
              aria-describedby="helpId"
              placeholder="New price"
              onChange={handleChangePop}
              name="price"
            />
            {ValidateError.price && (
              <p style={{ color: "red" }}>{ValidateError.price}</p>
            )}
          </div>

          <div class="mb-3 input_box">
            <lable>Royality</lable>
            <input
              type="number"
              class="form-control"
              aria-describedby="helpId"
              placeholder="Royality"
              onChange={handleChangePop}
              name="royality"
            />
            {ValidateError.royality && (
              <p style={{ color: "red" }}>{ValidateError.royality}</p>
            )}
          </div>
          <div class="mb-3 input_box">
            <lable>No of Token</lable>
            <input
              type="number"
              class="form-control"
              aria-describedby="helpId"
              placeholder="No of Token"
              onChange={handleChangePop}
              name="noOfToken"
            />
            {ValidateError.noOfToken && (
              <p style={{ color: "red" }}>{ValidateError.noOfToken}</p>
            )}
          </div>

          {/* <Row>
            <Col lg={6}>
              <p className="mb-0 grey">BNB Service fee</p>
            </Col>
            <Col lg={6}>
              <div className="mb-3"> %</div>
            </Col>
            <Col lg={6}>
              <p className="mb-0 grey">You will get</p>
            </Col>
            <Col lg={6}>
              <div className="mb-3"> BNB</div>
            </Col>
          </Row> */}
          <div className="d-flex gap-2 flex-wrap justify-content-between">
            <button class="cancel_btn" onClick={handleClose2}>
              Cancel
            </button>
            <button class="butn" onClick={downloadAvatar}>
              Continue
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {FormSubmitLoading && (
        <div className="loadBefore">
          <PropagateLoader
            color={"#72d438"}
            loading={FormSubmitLoading}
            cssOverride={override}
            size={25}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </>
  );
}
